/**
 * Whether the given request is done, whatever its outcome.
 */
export const didRequestFinish = (request: XMLHttpRequest) => request.readyState === 4;
